import React from 'react';
import './FloatingMenu.css';
import { Link } from 'react-router-dom';
function FloatingMenu({ visible, toggleMenu, menuRef}) {
  return (
    <div ref={menuRef} className={`floating-menu ${visible ? 'visible' : ''}`}>
      <ul className='Lista-floating-menu'>
        <Link className='Vinculo' to={'/'}><li onClick={toggleMenu}>Inicio</li></Link>
        {/*<hr/>*/}
        <Link className='Vinculo' to={'/consulta-tu-reserva'}><li onClick={toggleMenu}>Consulta tu reserva</li></Link>
        {/*<hr/>*/}
        <Link className='Vinculo' to={'/terminos-y-condiciones'}><li onClick={toggleMenu}>Terminos y condiciones</li></Link>
        {/*<hr/>*/}
      </ul>
    </div>
  )
}

export default FloatingMenu;